var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"col-span-full"},[_c('TeaserResults',{attrs:{"show-loading-animation":_vm.showLoadingAnimation,"teasers":_vm.teasers,"total-number-of-results":_vm.numberOfTotalResults},on:{"load-more-results":_vm.loadMoreSearchResults}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }